import React from "react";
import Blogrightsidebar from "./Blogrightsidebar";
import BlogGridItem from "./BlogGridItem";
import { Link } from "react-router-dom";

const BlogGrid = ({ BlogData, currentPage = 1 }) => {
    if (!BlogData || !BlogData.Blogs) {
        return null; // Don't render until data is loaded
    }

    const blogsPerPage = 10; 
    const totalBlogs = BlogData.Blogs.length;
    const totalPages = Math.ceil(totalBlogs / blogsPerPage);

    const indexOfLastBlog = currentPage * blogsPerPage;
    const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
    const currentBlogs = BlogData.Blogs.slice(indexOfFirstBlog, indexOfLastBlog);

    const getPaginationGroup = () => {
        let pages = [];
        if (totalPages <= 7) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            pages.push(1);
            if (currentPage > 3) {
                pages.push("...");
            }
            let start = Math.max(2, currentPage - 1);
            let end = Math.min(totalPages - 1, currentPage + 1);
            for (let i = start; i <= end; i++) {
                if (!pages.includes(i)) {
                    pages.push(i);
                }
            }
            if (currentPage < totalPages - 2) {
                pages.push("...");
            }
            if (!pages.includes(totalPages)) {
                pages.push(totalPages);
            }
        }
        return pages;
    };

    const paginationGroup = getPaginationGroup();

    return (
        <section className="blog_area_two sec_pad">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 blog_grid_info">
                        <div className="row">
                            {currentBlogs.map((blog) => (
                                <BlogGridItem
                                    date={blog.date}
                                    image={blog.image}
                                    Title={blog.title}
                                    description={blog.excerpt}
                                    body={blog.body}
                                    slug={blog.slug}
                                    btn="Read More"
                                    key={blog.id}
                                />
                            ))}
                        </div>

                        <ul className="list-unstyled page-numbers shop_page_number d-flex justify-content-center flex-wrap align-items-center mt_30" style={{ gap: "8px" }}>
                            {currentPage > 1 && (
                                <li>
                                    <Link
                                        to={`/blog-posts/${currentPage - 1}`}
                                        className="prev page-numbers"
                                    >
                                        <i className="ti-arrow-left"></i>
                                    </Link>
                                </li>
                            )}

                            {paginationGroup.map((item, index) => {
                                if (item === "...") {
                                    return (
                                        <li key={`ellipsis-${index}`}>
                                            <span className="page-numbers dots" style={{ border: "none", background: "transparent" }}>...</span>
                                        </li>
                                    );
                                }

                                const isActive = item === currentPage;
                                return (
                                    <li key={item}>
                                        {isActive ? (
                                            <span aria-current="page" className="page-numbers current">
                                                {item}
                                            </span>
                                        ) : (
                                            <Link to={`/blog-posts/${item}`} className="page-numbers">
                                                {item}
                                            </Link>
                                        )}
                                    </li>
                                );
                            })}

                            {currentPage < totalPages && (
                                <li>
                                    <Link
                                        to={`/blog-posts/${currentPage + 1}`}
                                        className="next page-numbers"
                                    >
                                        <i className="ti-arrow-right"></i>
                                    </Link>
                                </li>
                            )}
                        </ul>
                    </div>

                    <div className="col-lg-4">
                        <Blogrightsidebar BlogData={BlogData} />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BlogGrid;